import PricingPlans from "@/components/PricingPlans";
import DifferentiatorCallout from "@/components/DifferentiatorCallout";
import Disclaimer from "@/components/Disclaimer";

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <section className="bg-navy py-16 text-white sm:py-20">
        <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
          <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
            Simple, honest pricing
          </div>
          <h1 className="mt-3 font-serif text-4xl sm:text-5xl">
            Transparent pricing. <span className="text-gold">Lifetime peace of mind.</span>
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-white/75 sm:text-base">
            Pay only when your draft is ready. Optionally add a Senior Lawyer-Drafted Will for end-to-end assurance.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-testid="pricing-plans-section">
        <PricingPlans testIdPrefix="pricing" />
      </section>

      <section className="mx-auto max-w-6xl px-5 pb-16 sm:px-8">
        <DifferentiatorCallout testId="pricing-differentiator" />
      </section>

      <section className="mx-auto max-w-6xl px-5 pb-24 sm:px-8">
        <Disclaimer testId="pricing-disclaimer" />
      </section>
    </div>
  );
}
